import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from "@almothafar/angular-signature-pad";
import { HttpEventType } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as dayjs from "dayjs";
import {
  NgxImageCompressFormat,
  NgxImageCompressService,
} from "ngx-image-compress";
import { ComboDisplay } from "src/app/models/dto/combo-display.dto";
import dataURItoBlob from "src/app/utils/dataURItoBlob";
import { FuncionamientoService } from "src/app/views/catalogs/funcionamiento/funcionamiento.service";
import { OperadoresService } from "src/app/views/workers/operadores/operadores.service";
import Swal from "sweetalert2";
import { UnidadesService } from "../../unidades/unidades.service";
import { RecepcionService } from "../entrega.service";
import { AlertasSwalService } from "src/app/services/alerts.service";

@Component({
  selector: "app-form-entrega",
  templateUrl: "./form.component.html",
})
export class EntregaForm implements OnInit {
  @ViewChild("signatureChofer")
  public signatureChoferPad: SignaturePadComponent;
  @ViewChild("signatureSupervisor")
  public signatureSupervisorPad: SignaturePadComponent;

  public signaturePadOptions: NgSignaturePadOptions = {
    // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 400,
    canvasHeight: 300,
    backgroundColor: "rgb(255,255,255)",
  };

  @ViewChild("imageInput", { static: false }) public imageInput: ElementRef;
  @ViewChild("licenciaInput", { static: false })
  public licenciaInput: ElementRef;
  public fileList: File[] = [];
  public imagesList: any[] = [];

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  public unidades: any[] = [];
  public supervisores: ComboDisplay[] = [];
  public operadores: ComboDisplay[] = [];
  public funcionamientos: any[] = [];
  public observaciones: any[] = [];

  public currentUnidad: any = undefined;
  public currentIdUnidad: any = undefined;
  public currentOperador: any = undefined;
  public currentIdOperador: any = undefined;
  public currentSupervisor: any = undefined;
  public currentIdSupervisor: any = undefined;
  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  @Output() reload = new EventEmitter();

  public gasValue = 0;

  markerConfig = {
    "30": {
      color: "#555",
      size: 8,
      label: "30",
      type: "line",
    },
    "70": {
      color: "#555",
      size: 8,
      label: "60",
      type: "line",
    },
    "100": {
      color: "#555",
      size: 8,
      label: "100",
      type: "line",
    },
  };

  thresholdConfig = {
    "60": {
      color: "green",
      bgOpacity: 0.2,
    },
    "25": {
      color: "orange",
      bgOpacity: 0.2,
    },
    "0": {
      color: "red",
      bgOpacity: 0.2,
    },
  };

  public tarjetaCirculacionBool = false;
  public tarjetaCirculacionDate = dayjs().toDate();

  public polizaBool = false;
  public polizaDate = dayjs().toDate();

  public kms = 0;
  public llantas = 100;

  public golpesBool = false;
  public choferImg = "";
  public supImg = "";
  public licenciaImg = "";
  constructor(
    private fb: FormBuilder,
    private uniServ: UnidadesService,
    private opeServ: OperadoresService,
    private funcServ: FuncionamientoService,
    private serv: RecepcionService,
    private imageCompress: NgxImageCompressService,
    private alerts: AlertasSwalService,
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.uniServ.getParaRecibir().subscribe((s) => {
      this.unidades = s.sort((a, b) => a.NoControl - b.NoControl);
    });
    this.opeServ.getListas().subscribe((s) => {
      this.operadores = s.Choferes;
      this.supervisores = s.Supervisores;
    });
    this.funcServ.get().subscribe((s) => {
      this.funcionamientos = s.map((m) => {
        return { Id: m.IdFuncionamiento, Desc: m.Descripcion, Value: false };
      });
    });
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
  }

  public setUpdate(row: any) {
    this.defaults = row;
    this.mode = "create";
    let unidad = this.unidades.find((f) => f.IdUnidad == row.IdUnidad);

    this.currentIdUnidad = row.IdUnidad;
    this.currentUnidad = unidad;
    this.currentIdSupervisor = unidad.IdSupervisor;
    this.currentSupervisor = this.supervisores.find(
      (f) => f.Id == unidad.IdSupervisor,
    );
    this.currentIdOperador = unidad.IdChofer;
    this.currentOperador = this.operadores.find((f) => f.Id == unidad.IdChofer);
    this.loadImageChofer();
    this.loadImageSupervisor();
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public async create() {
    const firmaChoferData = this.signatureChoferPad.toDataURL("image/jpeg");
    const fileChofer = await this.fileFromDataUrl(firmaChoferData);

    const firmaSupervisorData =
      this.signatureSupervisorPad.toDataURL("image/jpeg");
    const fileSupervisor = await this.fileFromDataUrl(firmaSupervisorData);

    const context = {
      IdChofer: this.currentIdOperador,
      IdSupervisor: this.currentIdSupervisor,
      IdUnidad: this.currentIdUnidad,
      Kilometraje: this.kms,
      PolizaBool: this.polizaBool,
      PolizaVigencia: dayjs(this.polizaDate).toISOString(),
      TanqueGas: this.gasValue,
      TarjetaCirculacionBool: this.tarjetaCirculacionBool,
      TarjetaCirculacionVigencia: dayjs(
        this.tarjetaCirculacionDate,
      ).toISOString(),
      Funcionamientos: this.funcionamientos,
      Observaciones: this.observaciones,
      Llantas: this.llantas,
      Golpes: this.golpesBool,
      Tipo: "e",
      IdAsignacion: this.defaults.IdAsignacion,
    };
    this.serv
      .add(
        context,
        this.fileList,
        fileChofer,
        fileSupervisor,
        this.licenciaFile,
      )
      .subscribe(
        async (event) => {
          if (event.type === HttpEventType.Response) {
            if (event.ok) {
              const countGood = await this.retryUploadPhotos(event.body.id, this.fileList);
              const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${this.fileList.length} enviadas.`;


              this.alerts.correcta(
                "Correcto",
                "Entrega guardada." + mensajeEvidencias,
              );

              this.observaciones = [];

              this.currentUnidad = undefined;
              this.currentIdUnidad = undefined;
              this.currentOperador = undefined;
              this.currentIdOperador = undefined;
              this.currentSupervisor = undefined;
              this.currentIdSupervisor = undefined;

              this.gasValue = 0;

              this.tarjetaCirculacionBool = false;
              this.tarjetaCirculacionDate = dayjs().toDate();

              this.polizaBool = false;
              this.polizaDate = dayjs().toDate();

              this.kms = 0;

              this.choferImg = "";
              this.supImg = "";
              this.licenciaImg = "";
              this.imagesList = [];
              this.fileList = [];
              this.mode = "stanby";

              this.reload.emit();
              this.funcServ.get().subscribe((s) => {
                this.funcionamientos = s.map((m) => {
                  return {
                    Id: m.IdFuncionamiento,
                    Desc: m.Descripcion,
                    Value: false,
                  };
                });
              });
            } else {
              this.alerts.error("Error", "Ocurrio un error");
            }
          }
        },
        (err) => {
          this.alerts.error("Error", "Ocurrio un error");
        },
      );
    // this.onsave.emit({ mode: this.mode, value: this.form.value });
  }
  private async retryUploadPhotos(id: string, files: any[]): Promise<number> {
    let countGood = 0;
    let filesToTry = files.slice();

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const newFailed: any[] = [];
      for (const file of filesToTry) {
        try {
          await this.serv.addPhoto(id, file).toPromise();
          countGood++;
        } catch (error: any) {
          if (error.error.Message === "Fallo a guardar evidencia") {
            newFailed.push(file);
          }
        }
      }

      if (newFailed.length === 0) break;

      const imagesHtml = `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px;">
        ${newFailed
          .map(
            (file) => `
          <div style="aspect-ratio:1;overflow:hidden;border-radius:6px;border:1px solid #e2e8f0;">
            <img src="${URL.createObjectURL(file)}"
              style="width:100%;height:100%;object-fit:cover;display:block;" />
          </div>
        `,
          )
          .join("")}
      </div>`;

      const result = await Swal.fire({
        title: "Evidencias fallidas",
        html: `Las siguientes evidencias fallaron al subir:<br>${imagesHtml}`,
        showCancelButton: true,
        confirmButtonText: "Reintentar",
        cancelButtonText: "Continuar",
      });

      if (!result.isConfirmed) break;
      filesToTry = newFailed;
    }

    return countGood;
  }

  public update() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      // IdUnidad: [""],
      // IdEmpresa: [""],
      // IdTipoUnidad: [""],
      // NoControl: [""],
      // Serie: [""],
      // Placas: [""],
      // Modelo: [""],
      // Estado: [""],
      // FechaIngreso: [""],
    });
  }

  addObservacion(e) {
    const val = { Id: new Date().getTime().toString(36), Desc: e };

    this.observaciones.push(val);
  }

  removeObservacion(e) {
    this.observaciones = [...this.observaciones.filter((f) => f.id !== e)];
  }

  public getFile() {
    this.imageCompress
      .uploadMultipleFiles()
      .then((arrayOfFiles: NgxImageCompressFormat[]) => {
        for (let index = 0; index < arrayOfFiles.length; index++) {
          const element = arrayOfFiles[index];
          this.imageCompress
            .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
            .then((compressedImage) => {
              const blob = dataURItoBlob(compressedImage);
              this.imagesList.push(compressedImage);
              this.fileList.push(
                new File([blob], "Imagen" + new Date().getTime().toString(16)),
              );
            });
        }
      });
  }

  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }

  licenciaFile: File = undefined;
  OpenLicenseSelect() {
    this.licenciaInput.nativeElement.click();
  }

  public getLicense(licenciaInput: any) {
    if (licenciaInput.files.length > 0) {
      Array.from(licenciaInput.files).forEach(async (file) => {
        await this.processLicense(file);
      });
    }
  }

  processLicense(file: any) {
    const reader: FileReader = new FileReader();

    const promise: Promise<void> = new Promise((resolve) => {
      reader.onload = () => {
        this.licenciaImg = reader.result as string;
        this.licenciaFile = file;
        resolve();
      };
      reader.readAsDataURL(file);
    });
    return promise;
  }

  async fileFromDataUrl(dataURL) {
    const blob = await (await fetch(dataURL)).blob();
    const file = new File([blob], "fileName.jpg", {
      type: "image/jpeg",
      lastModified: new Date().getTime(),
    });
    return file;
  }

  cleanSupervisor() {
    this.signatureSupervisorPad.clear();
  }
  cleanChofer() {
    this.signatureChoferPad.clear();
  }
  public imgDef =
    "https://tanzolymp.com/images/default-non-user-no-photo-1.jpg";
  public valueImgChofer = "";
  public loadImageChofer() {
    this.opeServ.image(this.currentIdOperador).subscribe(
      (str) => (this.valueImgChofer = str),
      (err) => (this.valueImgChofer = this.imgDef),
    );
  }
  errorHandlerChofer(event) {
    event.target.src = this.imgDef;
  }
  public valueImgSupervisor = "";
  public loadImageSupervisor() {
    // this.supServ.image(this.currentIdSupervisor).subscribe( TODO
    //   (str) => (this.valueImgSupervisor = str),
    //   (err) => (this.valueImgSupervisor = this.imgDef)
    // );
  }
  errorHandlerSupervisor(event) {
    event.target.src = this.imgDef;
  }

  removeLicencia() {
    this.licenciaImg = "";
    this.licenciaFile = undefined;
  }
}
